import empty from './src/empty.vue'

empty.install = function install(Vue) {
  Vue.component(empty.name, empty)
}

export default empty



// WEBPACK FOOTER //
// ./src/components/empty/index.js